import { FoldersIcon, Paragraph } from "@datagame/ui";
import classNames from "classnames/bind";

import { Folder } from "../FoldersList";

import styles from "./FolderChip.module.scss";

const cx = classNames.bind(styles);

export interface FolderChipProps {
  folder: Folder;
  onSelect: (id: string) => void;
  selectedParentId: string;
}

export const FolderChip = ({ folder, onSelect, selectedParentId }: FolderChipProps) => {
  return (
    <div
      tabIndex={0}
      className={cx("folderChip", { selected: selectedParentId === folder.id })}
      key={folder.id}
      onClick={() => onSelect(folder.id)}
      onKeyDown={() => onSelect(folder.id)}
      role="button"
    >
      <FoldersIcon className={styles.test} />
      <Paragraph className={styles.chipName} size="small">
        {folder.name}
        <span>({folder.children?.length})</span>
      </Paragraph>
    </div>
  );
};
